export default __webpack_public_path__ + "static/media/88.38812d10.jpeg";